import { render, staticRenderFns } from "./RdiSubscribers.vue?vue&type=template&id=2e72619e&scoped=true"
import script from "./RdiSubscribers.vue?vue&type=script&lang=js"
export * from "./RdiSubscribers.vue?vue&type=script&lang=js"
import style0 from "./RdiSubscribers.vue?vue&type=style&index=0&id=2e72619e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e72619e",
  null
  
)

export default component.exports